import { useWonChime, playWonChime } from "@/lib/useWonChime";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { SpeakerHigh, SpeakerX, Play } from "@phosphor-icons/react";

/**
 * Opt-in chime for the Won recognition ribbon. Default OFF.
 *
 * A single quiet two-note bell (major third, sine wave, ~300ms) that plays
 * only when an opportunity crosses into Won AND the partner has opted in.
 * Uses the browser's WebAudio API so there is no external audio asset.
 */
export default function WonChimeCard() {
  const { enabled, setEnabled, syncedToServer } = useWonChime();

  return (
    <div className="border border-border bg-card p-6 md:col-span-2" data-testid="won-chime-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[0.625rem] font-mono uppercase tracking-widest text-eyebrow flex items-center gap-1.5">
            {enabled ? <SpeakerHigh size={12} weight="fill" /> : <SpeakerX size={12} weight="fill" />} Won chime
          </div>
          <div className="mt-1 text-sm text-muted-foreground max-w-lg">
            A single quiet two-note bell when an opportunity crosses into Won.
            Off by default — this is a governed recognition moment; keep it that way if silence suits you.
            <span className="block text-[0.625rem] font-mono uppercase tracking-widest text-eyebrow mt-1" data-testid="won-chime-sync-status">
              {syncedToServer
                ? "Synced to your profile · follows you across devices"
                : "Stored on this device"}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Switch
            checked={enabled}
            onCheckedChange={setEnabled}
            data-testid="won-chime-toggle"
            aria-label="Toggle Won chime"
          />
          <Button
            size="sm"
            variant="outline"
            onClick={playWonChime}
            className="rounded-none border-primary/40 h-9"
            data-testid="won-chime-preview"
            aria-label="Preview chime"
          >
            <Play size={12} weight="fill" className="mr-1.5" /> Preview
          </Button>
        </div>
      </div>
    </div>
  );
}
